import { InfoModalContainer } from '@features/regional-overview/components/info-modal/info-modal.container';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import DailyCountsTab from './daily-counts-tab/daily-counts-tab.component';
import FlightPredictionTab from './flight-prediction-tab/flight-prediction-tab.component';

interface InfoButtonModalProps {
  isVisible: boolean;
  onClose: () => void;
}

const InfoButtonModal = ({ isVisible, onClose }: InfoButtonModalProps): JSX.Element => {
  const [t] = useTranslation();

  const tabItems = [
    {
      key: 'digital-traps',
      label: t('pages.regional_overview.digital_traps.daily_counts.digital_traps'),
      children: <DailyCountsTab />
    },
    {
      key: 'flight-predictions',
      label: t('pages.regional_overview.digital_traps.daily_counts.flight_predictions'),
      children: <FlightPredictionTab />
    }
  ];

  return (
    <InfoModalContainer
      visible={isVisible}
      onDismiss={onClose}
      title='pages.regional_overview.digital_traps.info_button.pest_management'
      width={700}>
      <Tabs defaultActiveKey='digital-traps' items={tabItems} />
    </InfoModalContainer>
  );
};

export default InfoButtonModal;
